import React, { useState } from "react";
import { Modal, Input, Select, Upload, Button, Flex } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import GradientButton from "../../../../components/common/UI/GradientButton";
import "./index.scss";

const { TextArea } = Input;

interface AddTicketModalProps {
  visible: boolean;
  onClose: () => void;
  handleAfterClose: () => void;
}

const AddTicketModal: React.FC<AddTicketModalProps> = ({
  visible,
  onClose,
  handleAfterClose,
}) => {
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("Medium");
  const [file, setFile] = useState<File | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChange = (info: any) => {
    const latestFile = info.fileList[0]?.originFileObj || info.fileList[0];

    if (latestFile) {
      setFile(latestFile);
    } else {
      setFile(undefined);
    }
  };

  const handleSubmit = async () => {
    const url = ENDPOINTS.GET_TICKETS;

    if (!subject || !description || !priority) {
      toast.error("Please add all required fields");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("subject", subject);
    formData.append("description", description);
    formData.append("priority", priority);
    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await apiInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setSubject("");
        setDescription("");
        setFile(undefined);
        setPriority("Medium");
        toast.success("Ticket created successfully");
      }
    } catch (error) {
      console.error(error);
      toast.error("There was an error creating the Ticket");
    } finally {
      onClose();
      setLoading(false)
    }
  };

  return (
    <Modal
      title="Add Ticket"
      open={visible}
      onCancel={onClose}
      afterClose={handleAfterClose}
      footer={[
        <Flex justify="end" gap={8}>
          <Button
            className="cancel-btn"
            type="text"
            key="cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <GradientButton key="submit" onClick={handleSubmit} loading={loading}>
            Submit
          </GradientButton>
        </Flex>,
      ]}
      centered
      className="add-ticket-modal custom-modal"
    >
      <div className="form-group">
        <label>* Subject</label>
        <Input
          className="custom-input"
          required
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Enter subject"
        />
      </div>

      <div className="form-group">
        <label>* Description</label>
        <TextArea
          required
          className="text-area custom-text-area"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter description"
        />
      </div>

      <div className="form-group">
        <label>* Priority</label>
        <Select
          value={priority}
          onChange={setPriority}
          className="priority-select custom-select"
        >
          <Select.Option className="select-item" value="High">
            High
          </Select.Option>
          <Select.Option className="select-item" value="Medium">
            Medium
          </Select.Option>
          <Select.Option className="select-item" value="Low">
            Low
          </Select.Option>
        </Select>
      </div>

      <div className="form-group">
        <label>Attachment</label>
        <Upload
          beforeUpload={() => false}
          onChange={handleFileChange}
          multiple={false}
          maxCount={1}
          //   showUploadList={false}
        >
          <GradientButton icon={<UploadOutlined />}>Select file</GradientButton>
        </Upload>
      </div>
    </Modal>
  );
};

export default AddTicketModal;
